import { pdfjs } from 'react-pdf';
//reference - https://stackoverflow.com/questions/65740268/create-react-app-how-to-copy-pdf-worker-js-file-from-pdfjs-dist-build-to-your
const pdfjsWorker = require('react-pdf/node_modules/pdfjs-dist/build/pdf.worker.entry');
pdfjs.GlobalWorkerOptions.workerSrc = pdfjsWorker;

export function PDFViewerProvider(props: { children: JSX.Element }) {
  return props.children;
}
